import { createContext } from 'react';

const UserContext = createContext<{user: any, dispatchUser: any}>({
    user: {},
    dispatchUser: () => {}

})

export default UserContext